import React from 'react'
import PropTypes from 'prop-types'

const ButtonSpinner = () => (
  <div className="button spinner">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
)

const Button = ({ busy, name, text, onClick }) => {
  if (busy)
    return (
      <button
        type="button"
        disabled
        className={`${name ? `${name} ` : ''}button busy`}
      >
        {text}
        <ButtonSpinner />
      </button>
    )
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${name ? `${name} ` : ''}button`}
    >
      {text}
    </button>
  )
}

Button.propTypes = {
  busy: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
}

export default Button
